import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "src/components/ui/accordion";

export function CustomAccordion({ items }) {
  return (
    <div className="w-full font-sans">
      {/* Accordion items */}
      <Accordion className="space-y-3" defaultValue={items[0]?.title}>
        {items.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <AccordionItem
              value={item.question}
              className="border rounded-xl overflow-hidden data-[state=open]:bg-gradient-to-r from-blue-500 to-blue-600 data-[state=open]:text-white"
            >
              <AccordionTrigger className="px-4 py-5 hover:no-underline hover:bg-muted data-[state=open]:hover:bg-transparent [&[data-state=open]>svg]:text-white">
                <span className="text-lg font-bold">{item.question}</span>
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-4 pt-2">
                <div className="text-right">{item.answer}</div>
              </AccordionContent>
            </AccordionItem>
          </motion.div>
        ))}
      </Accordion>
    </div>
  );
}
